export default __webpack_public_path__ + "19baca1d9e9d43435b49f338188a0b26.png";